(function () {
  'use strict';
  angular.module('vcpatdocs')
    .component('imagingreferral', {
      restrict: 'E',
      bindings: {
        parentsave: '&',
        reset: '<'
      },
      templateUrl: 'vcpatdocs/imagingreferral-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'Config', 'Rlog', '$timeout',
        function ($log, Config, Rlog, $timeout) {
          let vm = this;

          vm.loadValues = loadValues;
          vm.toggleGroup = toggleGroup;
          vm.joinValues = joinValues;
          vm.flattenArray = flattenArray;

          vm.$onInit = function () {
            // reset/initialise resultset
            reset();
            //  get imagingvalues and groups from config
            Config.$find('imagingconfiguration').$then(imagingconfig => {
              vm.imagingconfig = imagingconfig;
            }, error => {
              Rlog.error('patdocs', 'newref', 'imagingconfiguration.$find() failed', {id: 'imagingconfiguration'});
            })
          }; // $onInit()

          vm.$onChanges = function (changes) {
            if (!changes.isFirstChange) {
              if (angular.isDefined(changes.reset)) {
                reset();
              }
            }
          };


          function reset() {
            vm.imagingvalues = [];
            vm.allvalues = [];
            vm.ginclude = [];
            vm.additionalvalues = [];
          }

          function toggleGroup() {
            let tmpa = [];
            for (let i = 0; i < vm.imagingconfig.groups.length; i++) {
              if (vm.ginclude[i] === true) {
                tmpa = tmpa.concat(vm.imagingconfig.groups[i].values);
              }
            }
            vm.autoselectedvalues = uniq(flattenArray(tmpa));
            joinValues();
          }

          function joinValues() {
            let tmpa = [];
            if (angular.isArray(vm.autoselectedvalues) && angular.isArray(vm.additionalvalues)) {
              tmpa = vm.autoselectedvalues.concat(flattenArray(vm.additionalvalues));
            }
            else {
              if (angular.isArray(vm.autoselectedvalues)) {
                tmpa = vm.autoselectedvalues;
              }
              if (angular.isArray(vm.additionalvalues)) {
                tmpa = flattenArray(vm.additionalvalues);
              }
            }
            vm.allvalues = uniq(tmpa);
            vm.parentsave({allvalues: vm.allvalues, ginclude: vm.ginclude, additionalvalues: vm.additionalvalues});
          }


          function flattenArray(a) {
            let tmpa = [];
            if (angular.isArray(a)) {
              for (let i = 0; i < a.length; i++) {
                tmpa.push(a[i].name);
              }
            }
            return tmpa;
          }

          // make array values uniq
          function uniq(a) {
            return a.sort().filter(function (item, pos, ary) {
              return !pos || item !== ary[pos - 1];
            });
          }

          // load and filter autocomplete values
          function loadValues($query) {
            // ngtags needs a promise as input
            let promise = new Promise(function (resolve, reject) {
              resolve(vm.imagingconfig.values);
            });
            return promise.then(function (values) {
              let filteredValues = values.filter(function (value) {
                return value.name.toLowerCase().indexOf($query.toLowerCase()) !== -1;
              });
              $log.debug('filtered values: ', filteredValues);
              return filteredValues;
            });
          }


        }
      ] // controller
    }); // component

// klammerfriedhof
}());